import SectionTitle from "@/components/common/SectionTitle";
import { ISectionTitle } from "@/models/common/common";
import {
    travelExperiencesSubTitle,
    travelExperiencesTitle,
} from "@/utils/mockData/homeMocks";
import React from "react";
import styles from "@/styles/detail/DetailBookingSidebar/TravelExperienceSectionDetail.module.scss";
import generalSvg from "@/utils/svg-icon/general";
import socialAndBrandSvg from "@/utils/svg-icon/socialAndBrand";

const TravelExperienceSectionDetail = () => {
    const title: ISectionTitle = {
        title: travelExperiencesTitle,
        subTitle: travelExperiencesSubTitle,
        classNameContainer: "p-0",
        alignment: "",
    };

    const { Star } = generalSvg;
    const { SketchLine } = socialAndBrandSvg;

    return (
        <div className={styles.container}>
            <SectionTitle sectionTitle={title} />
            <div className={styles.containerPackageSection}>
                <div className={`${styles.package} ${styles.packageQuality}`}>
                    <h1 className={styles.packageTitle}>Quality</h1>
                    <p className={styles.packageDescription}>
                        Our quality package formula offers the best travel
                        experience, combining comfortable hotels with fun group
                        outings. Our tours are guided by Italian experts—locals
                        with a true passion for tourism. Their goal is to make
                        your journey fun, insightful, relaxing, and truly
                        unforgettable.
                    </p>
                    {/* <div className="text-center py-2">
                        <CatQuality />
                    </div> */}
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>4-stars hotel</p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>
                            Round-trip private transfers from your arrival point
                            to accommodation, tailored to your itinerary
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>
                            Group experiences
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>
                            Assistance before, during, and after your stay
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>
                            Italian Experts
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconQuality}>
                            <Star />
                        </div>
                        <p className={styles.packageListText}>
                            Optional: Flights and Travel Insurance
                        </p>
                    </div>
                </div>
                <div className={`${styles.package} ${styles.packagePremium}`}>
                    <h1 className={styles.packageTitle}>Premium</h1>
                    <p className={styles.packageDescription}>
                        If you&apos;re looking to enjoy an exclusive Italian
                        experience, our premium package is perfect for you.
                        You&apos;ll stay in exclusive and unique accommodations
                        and enjoy the comfort of private transfers. Your private
                        party will be guided by our Italian experts, ensuring an
                        unforgettable journey.
                    </p>
                    {/* <div className="text-center py-2">
                        <CatPremium />
                    </div> */}
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Exclusive and unique accommodations
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Round-trip private transfers from your arrival point
                            to accommodation, tailored to your itinerary
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Private experiences
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Assistance before, during, and after your stay
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Italian Experts
                        </p>
                    </div>
                    <div className={styles.packageList}>
                        <div className={styles.packageListIconPremium}>
                            <SketchLine />
                        </div>
                        <p className={styles.packageListText}>
                            Optional: Flights and Travel Insurance
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TravelExperienceSectionDetail;
